import { useContext, useEffect, useState } from 'react';
import RootStoreContext from '../model/RootStoreContext';
import type { IGameEnvironment } from '../model/gameEnvironment/GameEnvironment';
import { useParams } from 'react-router-dom';
import { usePublishSnackbarNotification } from '@yakoffice/snackbar';

interface useGameEnvironmentsResult {
    isLoaded: boolean;
    gameEnvironments: IGameEnvironment[] | null;
}

export const useGameEnvironments = (callbackTrigger?: number) => {

    const rootStore = useContext(RootStoreContext);
    const publishNotification = usePublishSnackbarNotification();
    const { projectId } = useParams<{ projectId: string }>();

    const [result, setResult] = useState<useGameEnvironmentsResult>({ isLoaded: false, gameEnvironments: [] });

    useEffect(() => {
        setResult({ isLoaded: false, gameEnvironments: [] });

        rootStore.gameEnvironmentsStore.loadGameEnvironments()
            .then(() => {
                setResult({ isLoaded: true, gameEnvironments: rootStore.gameEnvironmentsStore.gameEnvironments });
            })
            .catch(e => publishNotification({
                text: `Error loading game environments: ${e.message}`,
                canClose: true
            }));
    }, [rootStore.gameEnvironmentsStore, publishNotification, projectId, callbackTrigger]);

    return result;
};
